import { Button, Group, Stack, Tabs, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CameraSettings } from './camera-settings';
import { DeviceSelect } from './device-select';
import { MicrophoneSettings } from './microphone-settings';
import { SoundSettings } from './reactions';

export function SettingsMenu({ onClose }: Readonly<{ onClose: () => void }>) {
    const { t } = useTranslation('settings');
    const { t: tReactions } = useTranslation('reactions');

    return (
        <div className="settings-menu" style={{ width: '100%', position: 'relative' }}>
            <Tabs defaultValue="media" keepMounted={false}>
                <Tabs.List mb="md">
                    <Tabs.Tab value="media">{t('tabs.media')}</Tabs.Tab>
                    <Tabs.Tab value="sounds">{tReactions('sounds.title')}</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="media">
                    <Stack gap="lg">
                        <Stack gap="sm">
                            <Title order={4}>{t('sections.camera')}</Title>
                            <CameraSettings />
                        </Stack>
                        <Stack gap="sm">
                            <Title order={4}>{t('sections.microphone')}</Title>
                            <MicrophoneSettings />
                        </Stack>
                        <Stack gap="sm">
                            <Title order={4}>{t('sections.speakers')}</Title>
                            <DeviceSelect kind="audiooutput" label={t('speakers.device')} />
                        </Stack>
                    </Stack>
                </Tabs.Panel>
                <Tabs.Panel value="sounds">
                    <SoundSettings />
                </Tabs.Panel>
            </Tabs>
            <Group justify="flex-end" mt="lg">
                <Button variant="default" onClick={onClose}>
                    {t('close')}
                </Button>
            </Group>
        </div>
    );
}
